const state = {
  syncStatus: null
}

const mutations = {
  updateSyncStatus (state, status) {
    state.syncStatus = status
  }
}

const getters = {
  syncStatus: state => {
    return state.syncStatus
  }
}

export default {
  state,
  mutations,
  getters
}
